exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.continent[data-v-c37a8de2] {\n    padding: 5px;\n    background-color: #C1CD23;\n    color: rgba(0,0,0,.7);\n    font-weight: 700;\n    width: 100%;\n}\n.country[data-v-c37a8de2] {\n    padding: 5px;\n    background-color: #66d6ff;\n    color: rgba(0,0,0,.7);\n    width: 60%;\n}\n.region[data-v-c37a8de2] {\n    padding: 5px;\n    margin-left: 20px;\n}\n.subregion[data-v-c37a8de2] {\n    padding: 5px;\n    margin-left: 40px;\n}\n", ""]);

// exports
